import React from 'react';
import Logo from '../logo/Rccglogo.png';
import DashBoard from '../nav logo/dashboard_imahe-removebg-preview.png';
import Member from '../nav logo/membersimage-removebg-preview.png';
import Attendance from '../nav logo/attendanceimage-removebg-preview.png';
import Finance from '../nav logo/finance-removebg-preview.png';
import Equipment from '../nav logo/equipment-removebg-preview.png';
import SMS from '../nav logo/sms-removebg-preview.png';
import Visitor from '../nav logo/visitor-removebg-preview.png';
import Users from '../nav logo/usersimage-removebg-preview.png';
import Settings from '../nav logo/settings-removebg-preview.png';
import LogOut from '../nav logo/logout-removebg-preview.png';
import Report from '../nav logo/report-removebg-preview.png';
import { NavLink } from 'react-router-dom';

function SideNavBar({ darkMode, closeMenu }) {
  const baseTextColor = darkMode ? 'text-yellow-200' : 'text-white';
	const hoverTextColor = 'group-hover:text-indigo-200';
  const getTextClasses = isActive =>
    `text-sm transition duration-500 ${
      isActive ? 'text-yellow-300' : `${baseTextColor} ${hoverTextColor}`
    }`;

  const getItemClasses = isActive =>
    `flex items-center gap-4 px-2 py-2 mt-5 ml-2 group transition-all duration-200 ${
      isActive ? 'border-l-4 rounded-l-lg border-yellow-300 shadow-lg' : 'border-transparent'
    }`;

  const handleNavClick = () => {
    if (closeMenu && window.innerWidth < 1024) {
      closeMenu();
    }
  };

	return (
		<div
			className={`w-full h-full transition-all duration-300 overflow-y-auto ${
				darkMode
					? 'bg-gradient-to-b from-indigo-950 to-indigo-800 text-indigo-100'
					: 'bg-gradient-to-b from-indigo-700 to-blue-500 text-white'
			}`}
		>
      <div className="flex flex-col items-center ml-8 mt-8">
        <img src={Logo} alt="Church Logo" className="h-16 w-auto object-contain" />
			<h1 className="text-xl lg:text-2xl text-center mt-6">Guest Management Portal</h1>
      </div>

      {/* Navigation Links with mobile close functionality */}
      <NavLink to="/dashboard" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={DashBoard} alt="Dashboard" className="w-6 h-6 text-teal-50" />
            <h1 className={getTextClasses(isActive)}>Dashboard</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/smsbroadcast" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={SMS} alt="SMS" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>SMS Broadcast</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/scheduled-sms" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={SMS} alt="Scheduled SMS" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Scheduled SMS</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/Guests" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={Visitor} alt="Visitor" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Guests</h1>
          </div>
        )}
      </NavLink>

     

      <NavLink to="/students" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={Users} alt="Students" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Students</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/users" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={Users} alt="Users" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Users</h1>
          </div>
        )}
      </NavLink>
      {/* <NavLink to="/scripture-promises" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={SMS} alt="Scripture Promises" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Scripture Promises</h1>
          </div>
        )}
      </NavLink> */}
      <NavLink to="/reports" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={Report} alt="Reports" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Reports</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/settings" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={Settings} alt="Settings" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Settings</h1>
          </div>
        )}
      </NavLink>

      <NavLink to="/logout" onClick={handleNavClick}>
        {({ isActive }) => (
          <div className={getItemClasses(isActive)}>
            <img src={LogOut} alt="Logout" className="w-6 h-6" />
            <h1 className={getTextClasses(isActive)}>Log Out</h1>
          </div>
        )}
      </NavLink>
    </div>
  );
}

export default SideNavBar;
